<template>
  <div v-if="rows.length" class="stock-line-lot-availability caption grey--text mt-1">
    <div
      v-for="(row, index) in rows"
      :key="`lot-avail-${index}`"
      class="stock-line-lot-availability__row"
    >
      {{ row }}
    </div>
  </div>
</template>

<script>
import { breakdownFromKg } from "@/common/stock/productPackagingConversion";

export default {
  name: "StockLineLotAvailability",
  props: {
    product: {
      type: Object,
      default: null,
    },
    availableKg: {
      default: null,
    },
  },
  computed: {
    rows() {
      if (this.availableKg == null || !Number.isFinite(Number(this.availableKg))) {
        return [];
      }

      const breakdown = breakdownFromKg(this.product, this.availableKg);
      const rows = [];

      const secondaryLabel =
        this.product?.secondary_unit?.name
        || this.product?.secondary_unit?.label
        || this.product?.secondary_unit?.code
        || breakdown.secondary_unit_code;

      if (breakdown.secondary_quantity != null && secondaryLabel) {
        rows.push(`${formatQty(breakdown.secondary_quantity)} ${secondaryLabel}`);
      }

      (breakdown.packaging_levels || []).forEach((level) => {
        if (level.quantity == null || !level.packaging_name) {
          return;
        }
        rows.push(`${formatQty(level.quantity)} ${level.packaging_name}`);
      });

      return rows;
    },
  },
};

function formatQty(value, decimals = 4) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return "0";
  }
  const fixed = number.toFixed(decimals).replace(/\.?0+$/, "");
  return fixed === "-0" ? "0" : fixed;
}
</script>

<style scoped>
.stock-line-lot-availability {
  line-height: 1.3;
  white-space: normal;
  word-break: break-word;
}
.stock-line-lot-availability__row + .stock-line-lot-availability__row {
  margin-top: 1px;
}
</style>
